import { validateUrl } from 'utils/ValidateUtils';
import i18n from 'i18next';
import _ from 'lodash';
import { AdLogoImageData, AdLogoType } from 'core/adLogo/AdLogo';
import mimeDB from 'mime-db';

export interface AdLogoFormModel {
  validateAdLogoImage(
    image: AdLogoImageData | undefined,
    type: AdLogoType
  ): any;
  validateLink(link: string | undefined, type: AdLogoType): any;
}

export type AdLogoFormProps = {
  readonly model: AdLogoFormModel;
  /**
   * 顯示「自訂廣告 Logo」開關，並依 addonFeatures.creatives.customizeAdLogo
   * 決定是否渲染廣告 Logo 設定內容（供經銷商設定頁使用）。
   * 未設定時為原本行為：渲染 fieldset/legend + 內容（供素材建立流程等使用）。
   */
  readonly withCustomizeToggle?: boolean;
  /**
   * 只輸出表單內容，不渲染自身的 fieldset/legend 外框
   * （供外層已有標題容器，如 CollapsibleSection 使用）。
   */
  readonly bare?: boolean;
};

export class DefaultAdLogoFormModel implements AdLogoFormModel {
  validateImage = (fileData) => {
    if (!fileData || (!fileData.file && !fileData.url)) {
      return i18n.t('formValidate.labels.emptyError');
    }

    if (!fileData.file) {
      return;
    }
    const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
    const file = fileData.file;
    if (validTypes.indexOf(file.type) === -1) {
      const extensions = _.get(mimeDB[file.type], 'extensions', ['Unknown']);
      return i18n.t('adLogoForm.labels.typeErrorHint', {
        type: extensions[0]
      });
    }

    const validWitdh = 50;
    const validHeight = 50;
    const width = fileData.width;
    const height = fileData.height;
    if (width !== validWitdh || height !== validHeight) {
      return i18n.t('adLogoForm.labels.sizeErrorHint', {
        size1: `${width} x ${height}`,
        size2: `${validWitdh} x ${validHeight}`
      });
    }
  };

  validateLink = (link: string | undefined, type: AdLogoType): any => {
    if (type === AdLogoType.CUSTOM) {
      return validateUrl(link);
    }
  };

  validateAdLogoImage = (
    image: AdLogoImageData | undefined,
    type: AdLogoType
  ): any => {
    if (type === AdLogoType.CUSTOM) {
      return this.validateImage(image);
    }
  };
}
